<template>
  <div class="motor-list">
    <div class="heading" v-text="type.name"></div>
    <div class="motors">
      <MotorPickerTypeMotor v-for="(motor, key) in groupedList"
         :key="key"
         :motor="motor"
         :type="type"
         :isAvailable="motor.available"
      ></MotorPickerTypeMotor>
    </div>
  </div>
</template>

<script>
import MotorPickerTypeMotor from './MotorPickerTypeMotor';
import {mapState} from 'vuex';
import {checkAvailability} from '@/store/formulas/motor';

function trueFirst(a, b) {
  return (a === b) ? 0 : a ? -1 : 1;
}

export default {
  name: 'MotorType',
  components: {
    MotorPickerTypeMotor,
  },
  props: ['type'],
  computed: {
    ...mapState({
      preference: state => state.preference,
    }),
    list() {
      let motors = this.type.motors;
      let power = this.preference.power;

      let arr = motors.map(motor => {
        motor.available = checkAvailability(motor, power);
        return motor;
      });
      arr.sort((a, b) => {
        if (a.kw > b.kw) return 1;
        if (a.kw < b.kw) return -1;
        if (a.voltage > b.voltage) return 1;
        if (a.voltage < b.voltage) return -1;
      })
      let sorted = arr.sort((a, b) => trueFirst(a.available, b.available));
      return sorted.sort();
    },
    groupedList() {
      let list = {};

      this.list.forEach(motor => {
        const key = motor.title + motor.kw;
        if (list.hasOwnProperty(key)) {
          list[key].motors.push(motor);
        } else {
          list[key] = {
            title: motor.title,
            kw: motor.kw,
            available: motor.available,
            motors: [motor],
          }
        }
      });

      return list;
    },
  },
}
</script>
